import { gql } from '../../__generated__/gql'

export const PLAN_QUERY = gql(`
  query plan($planName: String!) {
    plan(planName: $planName) {
      id
      isYearly
      price
      description
      isCustom
      isFree
      isGift
      name
    }
  }
`)
